import { invokeService } from '@alife/tarot';
import { getUrlParms } from '../pages/util/common';
import { md5 } from '../md5';
import { getAIData } from '../service';

const getExpParams = (exp) => {
  let res = {};
  let configs = exp.split(";");
  configs.map((configStr) => {
    let key = configStr.split(":")[0];
    let val = configStr.split(":")[1];
    res[key] = val;
  });
  return res;
};

const initData = {
  list: [],
  isLoading: false,
  bodyLoading: false,
  isEnd: false,
  reqOnlyList: [],
  formParams: {
    beginpage: 1,
    asyncreq: 1,
    keywords: "",
    keyword: "",
    sortType: "",
    descendOrder: "",
    province: "",
    city: "",
    priceStart: "",
    priceEnd: "",
    dis: "",
    ptid : window.p4pObject && window.p4pObject.ptid || ""
  }
};
const Module = {
  name: "offer",
  initState: initData,
  reducers: {
    setParams(state, action) {
      return {
        ...state,
        formParams: {
          ...state.formParams,
          ...action.payload
        }
      }
    },
    setReqOnlyList(state, action) {
      return {
        ...state,
        reqOnlyList: action.payload.reqOnlyList
      }
    },
    resetData() {
      return initData;
    },
    resetList(state) {
      return {
        ...state,
        list: []
      }
    }
  },
  effects: {
    * getHomeList(actions, { call }, state) {
      const timeStamp = new Date().getTime();
      const salt = `${timeStamp}${parseInt(10*Math.random())}`;
      const signOrigin = `pcsem${state.formParams.keywords}${salt}csb44T%34CiKj&FyRbCBJ`;
      const sign = md5(signOrigin);

      const payload = Object.assign({}, state.formParams, actions.payload, {
        exp: window.pageConfig.exp,
        salt: salt,
        sign: sign
      });
      if(window.pageConfig && window.pageConfig._hamlet_new_ad_supply_pc_) {
        payload._hamlet_new_ad_supply_pc_ = window.pageConfig._hamlet_new_ad_supply_pc_;
      }
      try {
        yield call(invokeService, "getOfferUrl", payload);
      } catch (e) {
        throw e;
      }
    },
    * getList(actions, { put, call }, state) {
      const timeStamp = new Date().getTime();
      const salt = `${timeStamp}${parseInt(10*Math.random())}`;
      const signOrigin = `pcsem${state.formParams.keywords}${salt}csb44T%34CiKj&FyRbCBJ`;
      const sign = md5(signOrigin);

      const payload = Object.assign({}, state.formParams, actions.payload, {
        exp: window.pageConfig.exp,
        salt: salt,
        sign: sign
      });
      if(window.pageConfig && window.pageConfig._hamlet_new_ad_supply_pc_) {
        payload._hamlet_new_ad_supply_pc_ = window.pageConfig._hamlet_new_ad_supply_pc_;
      }
      const preFormparams = state.formParams;
      yield put("offer/setValues", {
        isLoading: true
      });
      try {
        const result = yield call(invokeService, "getOfferUrl", payload);
        const offerResult = result.body.data.content ? result.body.data.content.offerResult : [];
        //请求
        const preList = state.list;
        const allList = preList.concat(offerResult);
        // 数据更新依然需要交给 reducer
        yield put("offer/setValues", {
          list: allList,
          isLoading: false,
          bodyLoading: false,
          reqOnlyList: offerResult
        });
        if (offerResult.length < 20) {
          yield put("offer/setValues", {
            isEnd: true
          });
        }
        yield put("offer/setParams", {
          asyncreq: preFormparams.asyncreq + 1
        })
        if (window.Light) {
          window.Light.light();
        }
      } catch (e) {
        yield put("offer/setValues", {
          isLoading: false,
          bodyLoading: false
        });
        throw e;
      }
    },
    *getGraphList(actions, { put, call }, state) {
      const timeStamp = new Date().getTime();
      const salt = `${timeStamp}${parseInt(10 * Math.random())}`;
      const signOrigin = `pcsem${state.formParams.keyword}${salt}csb44T%34CiKj&FyRbCBJ`;
      const sign = md5(signOrigin);

      let cpx = "";
      const { exp } = pageConfig;
      let expParams = getExpParams(exp || "");
      if(["D", "H"].includes(expParams.qztf)) {
        cpx = "cpc,nature";
      } else if(expParams.qztf == "E") {
        cpx = "cpc,free,nature";
      } else if(expParams.qztf == "F") {
        cpx = "cpc,cpt,cpm,free,nature";
      }

      const urlParams = getUrlParms();

      const payload = Object.assign({}, state.formParams, actions.payload, {
        exp: window.pageConfig.exp,
        cosite: window.p4pObject && window.p4pObject.cosite,
        salt: salt,
        sign: sign,
        hmaTid: 3,
        hmaQuery: "graphDataQuery",
        pidClass: "pc_list_336",
        cpx: cpx,
        api: "pcSearch",
        cosite: window.p4pObject && window.p4pObject.cosite,
        pv_id: window.pageConfig && window.pageConfig.pv_id,
        //count: 24,
        // DELETE
        // pid: "408011_0000",
        //debug: true,
      });
      if (window.pageConfig && window.pageConfig._hamlet_new_ad_supply_pc_) {
        payload._hamlet_new_ad_supply_pc_ =
          window.pageConfig._hamlet_new_ad_supply_pc_;
      }
      if(urlParams._debugMode_ == 1) {
        payload.debug = true;
      }

      const preFormparams = state.formParams;
      yield put("offer/setValues", {
        isLoading: true,
      });
      try {
        const result = yield call(invokeService, "getGraphOfferUrl", payload);
        const offerResult = result.body.module.offer ? result.body.module.offer.list : [];
        //请求
        const preList = state.list;
        const allList = preList.concat(offerResult);
        // 数据更新依然需要交给 reducer
        yield put("offer/setValues", {
          list: allList,
          isLoading: false,
          bodyLoading: false,
          reqOnlyList: offerResult,
        });
        if (offerResult.length < 20) {
          yield put("offer/setValues", {
            isEnd: true,
          });
        }
        yield put("offer/setParams", {
          asyncreq: preFormparams.asyncreq + 1,
        });
        if (window.Light) {
          window.Light.light();
        }
      } catch (e) {
        yield put("offer/setValues", {
          isLoading: false,
          bodyLoading: false,
        });
        throw e;
      }
    },
  },
};


export default Module;
